export default {
    'introduce.docs': 'Docs',
    'introduce.gitee': 'Gitee',
    'introduce.github': 'Github',
    'introduce.npm': 'Npm',
    'introduce.download': 'Download',
    'introduce.homepage': 'Home page',
    'banner.download': 'Download zip',
    'banner.description': 'A image crop plug-in for Vue,you can use it to rotate、zoom images and cut any size',
    'block1.title1': 'Easy to use',
    'block1.title2': 'Increase of efficiency',
    'block1.title3': 'You can use it in a few simple steps',
    'block1.title4': 'Install',
    'block1.title5': 'Import',
    'block1.title6': 'Register',
    'block1.title7': 'Code',
    'block1.title8': 'Return',
    'block2.title1': 'Online configuration',
    'block2.title2': 'Preview and generate code',
    'block2.title3': 'Use this tool to preview and generate code.',
    // 预览区域
    'block3.title1': 'Remote pictures src',
    'block3.title2': 'Crop local pictures',
    'block3.title3': 'Crop remote pictures',
    'block3.title4': 'Crop remote pictures(For IE9)',
    'block3.title5': 'Confirm',
    'block3.title6': 'Reset',
    'block3.title7': 'Download picture',
    'block3.title8': 'Cut it out and show it here',
    'block3.title9': 'Choose picture',
    // 捐赠
    'donation.title1': 'Donation',
    'donation.title2': 'Donate in support of the author',
    'donation.title3': 'Can you buy me a cup of coffee :)',
    // 设置项
    'config.title': 'Config tool',
    'config.label': 'Button text',
    'config.boxWidth': 'Tool width',
    'config.boxHeight': 'Tool height',
    'config.cutWidth': 'Selection box width',
    'config.cutHeight': 'Selection box height',
    'config.rate': 'Aspect ratio',
    'config.toolBgc': 'Toolbar background color',
    'config.crossOriginHeader': 'Cross origin header',
    'config.crossOrigin': 'Is cross origin',
    'config.isModal': 'Is modal',
    'config.showChooseBtn': 'Show select button',
    'config.lockScroll': 'Lock scroll',
    'config.sizeChange': 'Allow to change size',
    'config.moveAble': 'Allow to remove crop box',
    'config.tool': 'Show toolbar',
    'config.originalGraph': 'Crop original image',
    'config.saveCutPosition': 'Save cut position',
    'config.scaleAble': 'Allow scale image',
    'config.imgMove': 'Allow move image',
    'config.fileType': 'Return file type',
    'config.index': 'Return result with index',
    'config.smallToUpload': 'If choose image size less then defined Size,return file. sizeChange must be false',
    'config.toolBoxOverflow': 'Allow tool box out of picture range',
    'config.previewMode': 'Return results at any time',
    'config.WatermarkText': 'Watermark text',
    'config.WatermarkTextFont': 'Watermark size',
    'config.WatermarkTextColor': 'Watermark color',
    'config.WatermarkTextX': 'Watermark position x',
    'config.WatermarkTextY': 'Watermark position Y',
    'config.quality': 'Quality',
    'config.accept': 'accept file type',
};
